/**
 * Services Section
 * Grid of services offered by the business
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { usePortal } from '../../context/PortalContext';
import { Clock, DollarSign } from 'lucide-react';

const ServicesSection = ({ title = 'Our Services', limit = 6 }) => {
  const { services, branding } = usePortal();
  const displayServices = services.slice(0, limit);

  if (displayServices.length === 0) {
    return null;
  }

  return (
    <section className="section section-alt">
      <div className="container">
        <div className="section-heading">
          <h2>{title}</h2>
          <p>Professional services tailored to your needs</p>
        </div>

        <div className="grid grid-3">
          {displayServices.map(service => (
            <div key={service.id} className="card">
              {service.primaryImage && (
                <img 
                  src={service.primaryImage} 
                  alt={service.name} 
                  className="card-image"
                />
              )}
              <div className="card-content">
                <h3 className="card-title">{service.name}</h3>
                <p className="card-description">
                  {service.shortDescription || service.description?.substring(0, 100)}
                </p>
                
                <div style={styles.meta}>
                  {service.duration && (
                    <span style={styles.metaItem}>
                      <Clock size={16} /> {service.duration} min
                    </span>
                  )}
                  <span style={styles.metaItem}>
                    <DollarSign size={16} /> From ${service.price?.toFixed(2)}
                  </span>
                </div>

                <Link 
                  to={`/services#${service.slug || service.id}`}
                  style={{ ...styles.bookBtn, background: branding.primaryColor }}
                >
                  Book Now
                </Link>
              </div>
            </div>
          ))}
        </div>

        {services.length > limit && (
          <div style={styles.viewAll}>
            <Link to="/services" className="btn btn-secondary">
              View All Services
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

const styles = {
  meta: {
    display: 'flex',
    gap: '20px',
    marginTop: '15px',
    color: '#666',
    fontSize: '0.9rem',
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  bookBtn: {
    display: 'block',
    textAlign: 'center',
    padding: '12px',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    marginTop: '15px',
    transition: 'opacity 0.3s',
  },
  viewAll: {
    textAlign: 'center',
    marginTop: '40px',
  },
};

export default ServicesSection;
